export default "__VITE_ASSET__4fa60f92__"